import { useTheme } from '@mui/material';
import { ServiceLevel } from '@provision/service-level-utils';
import {
  formatServiceLevelWithCpp,
  getServiceLevelColor,
} from 'src/graphql/entities/service-level';
import { ChipCell } from 'src/pages/CustomViews/custom-views-entities-table';

export const ServiceLevelField = ({
  displayName,
  cppExpDate,
}: {
  displayName?: string | null;
  cppExpDate?: string | null;
}) => {
  const theme = useTheme();
  const value = formatServiceLevelWithCpp(displayName, cppExpDate);

  const { color, bg } = getServiceLevelColor(value as ServiceLevel, theme);

  return <ChipCell label={value} textColor={color} backgroundColor={bg} />;
};
